import lozad from 'lozad';
import { enableSpinner } from '@js/utilities/spinner';
import { executeAjaxScriptsFromHTMLResponse } from '@js/utilities/ajax/executeAjaxScripts';
import { isVisible } from '@js/utilities/isVisible';
import { urlDecorator } from './ajax/technicalParamsUrlDecorator';

const loadRemoteContent = async (url) => {
    try {
        const response = await fetch(urlDecorator(url));

        if (!response.ok) {
            return '';
        }

        const html = await response.text();

        return html;
    } catch (err) {
        const error = new Error('Error while loading remote content');
        console.error(error);
        return '';
    }
};

const remoteContentHandler = async (element) => {
    const url = element.dataset.remoteContent;

    if (!url) {
        return;
    }

    enableSpinner(element);

    const content = await loadRemoteContent(url);

    element.innerHTML = content;
    executeAjaxScriptsFromHTMLResponse(content);

    window.dispatchEvent(
        new CustomEvent('RemoteContentLoaded', {
            container: element,
        })
    );

    if (element.id) {
        window.dispatchEvent(
            new CustomEvent(`remoteContent.#${element.id}.loaded`, {
                detail: {
                    container: element,
                },
            })
        );
    }
};

const remoteContentListener = () => {
    const remoteContentElements = [
        ...document.querySelectorAll("[data-remote-content][data-loading='onload']"),
    ].filter((el) => !el.dataset.remoteContentInitialized);

    remoteContentElements
        .filter((el) => isVisible(el))
        .forEach((el) => {
            remoteContentHandler(el);

            el.dataset.remoteContentInitialized = true;
        });
};

const remoteContentManualListener = () => {
    const remoteContentElements = [
        ...document.querySelectorAll("[data-remote-content][data-loading='manual']"),
    ].filter((el) => !el.dataset.remoteContentInitialized);

    remoteContentElements.forEach((el) => {
        el.loadRemoteContent = () => {
            console.log('loading');
            remoteContentHandler(el);
        };

        el.dataset.remoteContentInitialized = true;
    });
};

const observer = lozad('[data-remote-content][data-loading="lozad"]', {
    load: async (el) => {
        remoteContentHandler(el);

        // window.dispatchEvent(
        //     new CustomEvent('remoteModal.loaded', {
        //         detail: {
        //             el,
        //         },
        //     })
        // );
    },
});

['DOMContentLoaded', 'RemoteContentLoaded'].forEach((ev) => {
    window.addEventListener(ev, () => {
        observer.observe();
        remoteContentManualListener();
    });
});

window.addEventListener('DOMContentLoaded', () => {
    remoteContentListener();
});
